module.exports = __webpack_public_path__ + "2f2bbc240a13bb277388bfeb64a8766b.pdf";